import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/providers/config/config.service';
import { MyAccountService } from 'src/app/providers/my-account/my-account.service';
import { UserManagerService } from 'src/app/providers/services/userManager/user-manager.service';
import { StorageService } from 'src/app/providers/storage.service';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit, OnDestroy {
  isProcessing =false;
  subscription = new Subscription();
  phoneNumberTypes = [
    {tp: 'mobile', value : ''},
    {tp: 'fixed', value : ''},

  ];
  invalidPhoneMessage = '';
  invalidNumber = true;
  errorMessage = '';
  phn = this.phoneNumberTypes[0];
  updateForm: FormGroup = this.fb.group({
      phone: ['', [Validators.required]],
      pvd: ['', [Validators.required, Validators.minLength(3)]],
  });

  constructor(
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {phone: string, msg:string, header:string, isConfirmDialog:boolean},
    public accountService: MyAccountService,
    private translate: TranslateService,
    private storageService: StorageService,
    public config: ConfigService,
    public userService: UserManagerService) {
      this.updateForm.controls.phone.setValue(data.phone);
    }

  ngOnInit() {
    // this.showConfirmModal = false;
    this.accountService.getProviders(1).then(res =>{});
    this.subscription.add(
      this.updateForm.get('phone')!.valueChanges.subscribe(value => {
      this.verifyPhoneNumber(value);
      })
    );
  }
  onYesClick(){
    // this.showConfirmModal = true;
    // this.modalService.destroy();
    // this.modalService.init(MyAccountComponent, { activeTab: '1' }, {});
  }

  verifyPhoneNumber(phoneNumber: any){
    let mask = this.updateForm.controls.pvd.value;
    if(mask.length < 1){
      this.invalidNumber = true;
      this.invalidPhoneMessage = 'select_provider';
    }else {
      let length1 = mask && mask.indexOf('#') > -1  ? mask.split('#')[1]: this.config.phoneNumberLength;
      var pattern = /^[0-9]+$/
      var checkval = pattern.test(phoneNumber);
      if(!checkval){
        this.invalidPhoneMessage ="invalid_character_in_phone_number";
      }
      let phoneLength = phoneNumber.toString().length
      if( length1 && (Number(phoneLength) !== Number(length1))){
        checkval =false;
        this.invalidPhoneMessage ="invalid_length";
      }
      if(!checkval) {
        this.invalidNumber = true;
      } else {
        let testMasks: string[] = mask && mask.indexOf('#')? mask.split('#')[0].split('-'): [];
        if(testMasks && testMasks.length>0) {
          for(let maskitem of testMasks){
            if (phoneNumber.toString().indexOf(maskitem) == 0){
              this.invalidNumber = false;
              break;
            }
            else{
              this.invalidNumber = true
              this.invalidPhoneMessage = this.translate.instant("invalid_phone_start", {starts: testMasks.join(` ${this.translate.instant('or')} `)});
            }
          }
        } else this.invalidNumber =false
      }
    }
  }
  saveChanges(){
    this.isProcessing = true;
    let {pvd, phone} = this.updateForm.value;
    if(pvd){

      this.config.tempData.phone_number = this.config.country_code.concat(phone);
      this.userService.updateUser({...this.config.tempData, phone_number: phone}).then(data =>{
        if (data.hasOwnProperty('erc') && data.erc == '1') {
          this.storageService.setCookie('session', this.config.tempData.session, this.config.expiry);
          this.userService.userData = this.config.tempData;
          this.storageService.save('userData', this.config.tempData.session);
          this.isProcessing = false;
          // this.modalService.isSuccess = true;
          // this.modalService.isError = false;
          // this.modalService.msg = data.msg;
          // this.modalService.showModal();
          this.dialogRef.close({success: true, msg: data.msg});
        } else {
          this.isProcessing = false;
          this.dialogRef.close({success: false, msg: data.msg});
        }

        // this.userService.isProcessing = false;
      }).catch(err => {
        // this.modalService.destroy();
        // this.modalService.isSuccess = false;
        // this.modalService.isError = true;
        // this.modalService.msg = 'connection_error';
        // this.modalService.showModal();
        console.log(err);
        this.isProcessing = false;
        this.dialogRef.close({success: false, msg: 'connection_error'});
      });
    }
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
